// ══════════════════════════════════════════════════════
// PeptideVault v6.5 — Recently Deleted / Trash (BN27)
// Soft-delete with 30-day retention.
// ══════════════════════════════════════════════════════
function renderTrashTab() {
  var items = (S.trash || []).slice().sort(function(a, b) { return (b.deletedAt || '').localeCompare(a.deletedAt || '') })
  // Auto-purge items older than 30 days
  var cutoff = fmtLD(addDays(new Date(), -30))
  var purged = items.filter(function(t) { return (t.deletedAt || '') < cutoff })
  if (purged.length > 0) { S.trash = (S.trash || []).filter(function(t) { return (t.deletedAt || '') >= cutoff }); items = S.trash.slice(); save() }

  return '<div class="tab-content" style="animation:fadeIn .25s ease">' +
    '<div class="row" style="margin-bottom:16px"><h2 style="font-size:20px;font-weight:700">Recently Deleted</h2><div class="spacer"></div>' +
    '<span style="font-size:12px;color:var(--text4)">' + items.length + ' items \u00B7 auto-purged after 30 days</span></div>' +
    (items.length === 0 ? '<div class="card"><div class="empty-state" style="padding:48px"><div class="empty-icon">\uD83D\uDDD1\uFE0F</div><p>Trash is empty</p></div></div>' :
      items.map(function(t) {
        return '<div class="card" style="margin-bottom:8px;padding:12px">' +
          '<div style="display:flex;align-items:center;gap:8px">' +
            '<div style="flex:1"><div style="font-size:13px;font-weight:600">' + esc(t.entityType) + ': ' + esc(t.data && t.data.name || t.data && t.data.reportNo || t.entityId) + '</div>' +
            '<div style="font-size:11px;color:var(--text4)">Deleted ' + (t.deletedAt ? t.deletedAt.slice(0, 10) : '') + '</div></div>' +
            '<button class="btn btn-secondary btn-xs" onclick="restoreFromTrash(\'' + t.id + '\')">Restore</button>' +
            '<button class="btn btn-danger btn-xs" onclick="permanentDelete(\'' + t.id + '\')">Purge</button>' +
          '</div></div>'
      }).join('')) +
  '</div>'
}
function softDelete(entityType, entityId, data) {
  S.trash.push({ id: uid(), entityType: entityType, entityId: entityId, data: data, deletedAt: now() })
}
function restoreFromTrash(trashId) {
  var item = (S.trash || []).find(function(t) { return t.id === trashId })
  if (!item) return
  var target = { protocol: 'protocols', supplement: 'supplements', note: 'notes', coa: 'coas', vendor: 'vendors' }[item.entityType]
  if (target && S[target] && item.data) { S[target].push(item.data); S.trash = S.trash.filter(function(t) { return t.id !== trashId }); save(); showToast('Restored'); render() }
}
function permanentDelete(trashId) { if (!confirm('Permanently delete? This cannot be undone.')) return; S.trash = (S.trash || []).filter(function(t) { return t.id !== trashId }); save(); render() }
export { renderTrashTab, softDelete, restoreFromTrash, permanentDelete }
